import React, { useState } from 'react'
import { pieArcLabelClasses, PieChart, pieClasses } from '@mui/x-charts/PieChart'
import { t } from 'i18next'
import { Card, Flex, Segmented } from 'antd'
import Title from 'antd/es/typography/Title'
import { APPOINTMENT_COLORS } from '../../Common/Color'

export default function AppointmentsSummaryChart ({ appointments }) {
  const [displayedValue, setDisplayedValue] = useState('Type')
  const format = (appointments, label, id, color) => {
    return { id, value: appointments.length, label, color }
  }
  const innerRadius = 30
  const middleRadius = 80

  const stateFilter = (array, state) => (array.filter(s => s.state === state))
  const typeFilter = (array, type) => (array.filter(s => s.type === type))
  const states = ['auto_cancel', 'cancel', 'not_confirmed', 'clean_in_progress', 'done', 'late', 'in_progress', 'person_left', 'waiting']
  const types = ['PatientAppointment', 'CleaningAppointment', 'MaintenanceAppointment', 'WorkAppointment']

  const stateToAppointmentTypeData = {
    innerData: states.map(state => (
      format(stateFilter(appointments, state), t(`Admin.Appointment.state.${state}`), state, t(`Admin.Appointment.stateColor.${state}`))
    )).filter(item => item.value > 0),
    outerData: states.map(state => (
      types.map(
        type => format(typeFilter(stateFilter(appointments, state), type), t(`Admin.Appointment.type.${type}`), `${state}_${type}`, APPOINTMENT_COLORS[type])
      )
    )).flat().filter(item => item.value > 0)
  }

  const appointmentTypeToStateData = {
    innerData: types.map(type => (
      format(typeFilter(appointments, type), t(`Admin.Appointment.type.${type}`), type, APPOINTMENT_COLORS[type])
    )).filter(item => item.value > 0),
    outerData: types.map(type => (
      states.map(
        state => format(stateFilter(typeFilter(appointments, type), state), t(`Admin.Appointment.state.${state}`), `${type}_${state}`, t(`Admin.Appointment.stateColor.${state}`))
      )
    )).flat().filter(item => item.value > 0)
  }

  const data = displayedValue === 'Type' ? appointmentTypeToStateData : stateToAppointmentTypeData

  return (
    <Card>
      <Flex vertical align='center' gap='1em'>
        <Title level={5} style={{ textAlign: 'center' }}>
          {`${appointments.length} ${t('Admin.Statistic.CanceledChart.title')}`}
        </Title>
        <Segmented size="large" options={['Type', 'Statut']} onChange={setDisplayedValue} style={{ width: 'fit-content' }}/>
        <PieChart series={[
          {
            innerRadius,
            outerRadius: middleRadius,
            arcLabel: (item) => `${item.value} ${item.label}`,
            data: data.innerData,
            cornerRadius: 3
          },
          {
            innerRadius: middleRadius,
            outerRadius: middleRadius + 30,
            data: data.outerData,
            cornerRadius: 3
          }
        ]}
        sx={{
          [`.${pieClasses.seriesLabels} .${pieArcLabelClasses.root}`]: {
            color: 'white'
          }
        }}
        width={250} height={250} hideLegend />
      </Flex>
    </Card>
  )
}
